import React from "react";
import "./ContactPageMap.css";

const ContactPageMap = () => {
  return (
    <div className="container ContactPageMap-container">
      <div className="ContactPageMap-map">
        <iframe
          title="TNPY AMPICON"
          className="ContactPageMap-iframe"
          src="https://www.google.com/maps?q=College+Auditorium,+Apollo+Cancer+Centre+-+Vanagaram,+Chennai&output=embed"
          allowFullScreen=""
          loading="lazy"
          width="600"
          height="450"
          style={{ border: 0 }}
        ></iframe>

        <div className="ContactPageMap-marker">
          <div className="ContactPageMap-marker-icon">
            <i className="bi bi-geo-alt-fill"></i>
          </div>
          <div className="ContactPageMap-info-box">
            <h5>Address:</h5>
            <p>
              College Auditorium, Apollo Cancer Centre - Vanagaram, Chennai.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPageMap;
